import { ContentfulSizeChart } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'
import ContentfulProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'

enum ProductSizeGuideDesignVariant {
  DESIGN_1,
  DESIGN_2,
}

interface ProductSizeGuide {
  sizeChart: ContentfulSizeChart
  measuringGuide?: ContentfulProductMeasuringGuide
}

interface PDPProductSizeGuide {
  tabName: string
  productSizeGuides: ProductSizeGuide[]
}

export { ProductSizeGuideDesignVariant, ProductSizeGuide, PDPProductSizeGuide }
